import { render, staticRenderFns } from "./GoogleAd.vue?vue&type=template&id=7b9b53a7&"
import script from "./GoogleAd.vue?vue&type=script&lang=js&"
export * from "./GoogleAd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b9b53a7')) {
      api.createRecord('7b9b53a7', component.options)
    } else {
      api.reload('7b9b53a7', component.options)
    }
    module.hot.accept("./GoogleAd.vue?vue&type=template&id=7b9b53a7&", function () {
      api.rerender('7b9b53a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/GoogleAd.vue"
export default component.exports